import { useMemo } from "react";
import { CgProfile } from "react-icons/cg";
import { HiOutlineMail } from "react-icons/hi";
import { RiLockPasswordFill } from "react-icons/ri";
import { Description, SubTitle } from "../../Components/CustomComponents";
import { ROUTES } from "./contants";
import styles from "./styles/Menu.module.scss";

export default function Menu({ route, setRoute }) {
  const OPTIONS = useMemo(() => {
    return [
      {
        label: "Change Password",
        route: ROUTES.CHANGE_PASSWORD,
        icon: <RiLockPasswordFill size={20} />,
      },
      {
        label: "Profile",
        route: ROUTES.PROFILE,
        icon: <CgProfile size={20} />,
      },
      {
        label: "Email Template & Logo",
        route: ROUTES.EMAIL_TEMPLATE,
        icon: <HiOutlineMail size={20} />,
      },
      // {
      //   label: "Set Commission",
      //   route: ROUTES.COMMISSION,
      //   icon: <IoIosSettings size={20} />,
      // },
      // {
      //   label: "Set Points",
      //   route: ROUTES.POINTS,
      //   icon: <VscActivateBreakpoints size={20} />,
      // },
      // {
      //   label: "Terms And Conditions",
      //   route: ROUTES.TERMS_CONDITIONS,
      //   icon: <SiGoogledocs size={20} />,
      // },
      // {
      //   label: "Privacy Policy",
      //   route: ROUTES.PRIVACY_POLICY,
      //   icon: <SiGoogledocs size={20} />,
      // },
      //   {
      //     label: "Contact Us",
      //     route: ROUTES.CONTACT_US,
      //     icon: <MdMarkEmailRead size={20} />,
      //   },
    ];
  }, []);

  const handleMenuItemClick = (route) => {
    setRoute(route);
  };

  return (
    <div className={styles.Menu}>
      <SubTitle text="Setting" />
      <Description
        text="Manage your account preferences and system configurations. You can update your password, profile, and platform settings to ensure a secure and personalized admin experience."
        classes="mt-1 mb-4 fs-8"
      />
      {OPTIONS.map((item, index) => {
        return (
          <div
            className={`${styles.option} my-3 ${
              route === item.route ? styles.active : ""
            }`}
            key={index}
            onClick={() => handleMenuItemClick(item.route)}
          >
            <span className={styles.icon}>{item?.icon}</span>
            <Description text={item.label} classes="fs-7" />
          </div>
        );
      })}
    </div>
  );
}
